import { ShoppingData } from "../../api/shoppingTyped/Shopping";
import { JsonUtil } from "../../cutil/JsonUtil";
import { FuncResponse, FuncResponseType, FunctionBase, } from "../../storyV2/function/FunctionBase";
import { SearchInfoPagination, SearchInfoWrapper } from "../../storyV2/model/SearchInfoWrapper";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
export class AmazonShoppingFunction extends FunctionBase {
    async run(input, identityInfo, variableList = [], page = 1) {
        const res = await this.getAmazonShoppingInfo(input, page, FunctionUtil.createAbortUuid(identityInfo));
        const querys = res["querys"];
        let items = [];
        for (const query of querys) {
            const data = JsonUtil.toModelFromType(ShoppingData, res[query]);
            items.push(...(data?.items ?? []));
        }
        const pagination = new SearchInfoPagination(page);
        const searchInfoWrapper = new SearchInfoWrapper(input, pagination, items);
        return new FuncResponse(FuncResponseType.AMAZON_SHOPPING, searchInfoWrapper);
    }
    async getAmazonShoppingInfo(query, page, uuid) {
        const result = await this.brainClient.openAi.getAmazonShoppingInfo(query, page, uuid);
        return result?.data?.data;
    }
}
